export interface BookingParticipantData {
  name: string;
  lastName: string;
  lastDive: Date | null;
  loggedDives: number;
  dateOfBirth: Date | null;
  nationality: string;
  certifications: string[];
  certificationPhotoUrl?: string | null;
  hasDivingInsurance?: boolean | null;
  insurancePolicyUrl?: string | null;
}

export const NO_CERTIFICATION_LABEL = "No certification";

export { parseParticipantCertifications } from "@/app/libs/participantCertifications";

export function participantRequiresCertificationCard(
  certifications: string[]
): boolean {
  if (!certifications.length) return false;
  return !certifications.includes(NO_CERTIFICATION_LABEL);
}

export function requiresCertificationDetails(category: string): boolean {
  return (
    category !== "Open Water" &&
    category !== "Intro" &&
    category !== "Snorkel"
  );
}

export function showCertificationPhotoUpload(category: string): boolean {
  return category !== "Snorkel";
}

export function emptyParticipantData(): BookingParticipantData {
  return {
    name: "",
    lastName: "",
    lastDive: null,
    loggedDives: 0,
    dateOfBirth: null,
    nationality: "",
    certifications: [],
    certificationPhotoUrl: null,
    hasDivingInsurance: null,
    insurancePolicyUrl: null,
  };
}
